
<script>
    import { TOKEN_SESSION, USER, TOAST_MESSAGE} from '../../stores'
    import { onMount } from 'svelte';
    import CrudButtons from "./CrudButtons.svelte";
    import GLOBALS from "../../globals/GLOBALS";

    let secretarios= []

    onMount(async () => {
        await _refreshSecretarios()
    })

    const _refreshSecretarios = async () => {
        await _SERVER_QUERY('SECRETARIOS','GETDATA')
        .then( json => { 
            secretarios = [ ...json.data ]
            newRecord  = {
                sec_id      : 0,
                sec_nombre  : null,
                sec_cargo  : null,
                sec_f_desde : null,
                sec_f_hasta : "2999-12-31"
            }  
            secretarios[1]       
        } )
        .catch( error => console.log(error) )
    }

    let newRecord  = {
        sec_id      : 0,
        sec_nombre  : null,
        sec_cargo  : null,
        sec_f_desde : null,
        sec_f_hasta : "2999-12-31"
    }

    const _handleCRUDAction = async ( index, action ) => {
        const { opcion } = action.detail
        switch( opcion ) {
            case "CREATE" :
                await _SERVER_QUERY('SECRETARIOS','CREATE', newRecord).then( async json => await _refreshSecretarios()).catch( json => console.log(json))
            break
            case "UPDATE" :
                await _SERVER_QUERY('SECRETARIOS','UPDATE', secretarios[index]).then( async json => await _refreshSecretarios()).catch( json => console.log(json))
            break
            case "DELETE" :
                await _SERVER_QUERY('SECRETARIOS','DELETE', secretarios[index]).then( async json => await _refreshSecretarios()).catch( json => console.log(json))
            break
        }
    }

    const _SERVER_QUERY = ( OPCION, ACTION, data ) => new Promise (async (resolve, reject) => {
        const URL = GLOBALS.URL;
        const bearer = "Bearer " + $TOKEN_SESSION;
        await fetch(`${URL}/API/configuraciones/${OPCION}/${ACTION}`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                Authorization: bearer,
                "Content-type": "application/json;charset=UTF-8",
            },
        })
        // Handle success
        .then((response) => response.json()) // convert to json
        .then((json) => {
            if (json.result === "success") {
                switch(`${OPCION}/${ACTION}`){
                    case "SECRETARIOS/GETDATA":
                        if (json.result === "success") {
                            resolve(json)
                        }else{
                            reject(json)
                        }
                    break
                    case "SECRETARIOS/CREATE":
                    case "SECRETARIOS/UPDATE":
                    case "SECRETARIOS/DELETE":
                        if (json.result === "success") {
                            resolve(json)
                        }else{
                            reject(json)
                        }
                        TOAST_MESSAGE.set(json)
                    break;
                }
                return
            }else{
                TOAST_MESSAGE.set(json)
                reject({result:"error",message:`Hubo un error en ${OPCION}/${ACTION}`, data:[]})
                if (json.status === 403) TOKEN_SESSION.set(null)
            }
            
        }) //print data to console
        .catch((err) => reject({result:"error",message:`Hubo un error en ${err}`, data:[]})); // Catch errors
    })
</script>

<div class="main">
    <div class="flex-column justify-content-start pt-2">
        <div class="d-flex direction-row justify-content-between">
            <h4>Mantenimiento de Nombres de Secretarios de Hacienda</h4>
        </div>
    </div>
    {#each secretarios as item, index (item.index)}
        <div class="d-flex flex-row justify-content-start">
            <div class="form-floating mb-1 ms-1 "><input disabled="" bind:value={secretarios[index].sec_nombre}  type="text" class="form-control" id="sec_nombre"  placeholder="Nombre" > <label for="sec_nombre">Nombre</label></div>
            <div class="form-floating mb-1 ms-1 "><input disabled="" bind:value={secretarios[index].sec_cargo}  type="text" class="form-control" id="sec_cargo"  placeholder="Cargo" > <label for="sec_cargo">Cargo</label></div>
            <div class="form-floating mb-1 ms-1 "><input disabled="" bind:value={secretarios[index].sec_f_desde} type="date" class="form-control" id="sec_f_desde" placeholder="Desde" > <label for="sec_f_desde">Desde</label></div>
            <div class="form-floating mb-1 ms-1 "><input disabled="" bind:value={secretarios[index].sec_f_hasta} type="date" class="form-control" id="bas_periodo" sec_f_hasta="Hasta" > <label for="sec_f_hasta">Hasta</label></div>
            <div class="form-floating mb-1 ms-1 d-flex align-items-center"><CrudButtons on:click={(action) => _handleCRUDAction( index,action )} nuevo={false} guardar={true} eliminar={true}/></div>
        </div>
    {/each}
    <div class="d-flex flex-row justify-content-start">
        <div class="form-floating mb-1 ms-1 "><input style="background-color:#efefef"disabled="" bind:value={newRecord.sec_nombre}  type="text" class="form-control" id="sec_nombre" placeholder="Nombre" > <label for="sec_nombre">Nombre</label></div>
        <div class="form-floating mb-1 ms-1 "><input style="background-color:#efefef"disabled="" bind:value={newRecord.sec_cargo}  type="text" class="form-control" id="sec_cargo" placeholder="Cargo" > <label for="sec_cargo">Cargo</label></div>
        <div class="form-floating mb-1 ms-1 "><input style="background-color:#efefef"disabled="" bind:value={newRecord.sec_f_desde} type="date" class="form-control" id="sec_f_desde" placeholder="Desde" > <label for="sec_f_desde">Desde</label></div>
        <div class="form-floating mb-1 ms-1 "><input style="background-color:#efefef"disabled="" bind:value={newRecord.sec_f_hasta} type="date" class="form-control" id="bas_periodo" sec_f_hasta="Hasta"> <label for="sec_f_hasta">Hasta</label></div>
        <div class="form-floating mb-1 ms-1 d-flex align-items-center"><CrudButtons on:click={(action) => _handleCRUDAction( 0,action )} nuevo={true} guardar={false} eliminar={false}/></div>
    </div>
</div>

<style>
    .main {
        margin-bottom: 52px;
    }    
</style>
